import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import {
  TNinusiSeikyuUtiwakePutReq,
  荷主請求マスタ受注配車,
  荷主請求マスタ月固定,
  荷主請求マスタ手作成,
} from "./TNinusiSeikyu"

export const 荷主請求マスタ受注配車Schema: JSONSchemaType<荷主請求マスタ受注配車> =
  {
    title: "荷主請求マスタ受注配車",
    type: "object",
    properties: {
      請求書作成区分コード: {
        type: "string",
        enum: ["1"],
        title: "請求書作成区分コード",
      },
      請求書印刷区分コード: {
        type: "string",
        title: "請求書印刷区分コード",
      },
      明細小計表示区分コード: {
        type: "string",
        title: "明細小計表示区分コード",
      },
      品代端数計算区分コード: {
        type: "string",
        title: "品代端数計算区分コード",
      },
      // 消費税表示区分コード: {
      //   type: "string",
      //   title: "消費税表示区分コード",
      // },
      消費税計算区分コード: {
        type: "string",
        title: "消費税計算区分コード",
      },
      明細ソート区分コード: {
        type: "string",
        title: "明細ソート区分コード",
      },
      // 高速料税込区分コード: {
      //   type: "string",
      //   title: "高速料税込区分コード",
      // },
      コース編集区分コード: {
        type: "string",
        title: "コース編集区分コード",
      },
      荷主コード: {
        type: "string",
        title: "荷主コード",
      },
      表紙分割コード: {
        type: "string",
        title: "表紙分割コード",
      },
      表紙名: {
        type: "string",
        title: "表紙名",
      },
      請求先名: {
        type: "string",
        title: "請求先名",
        nullable: true,
      },
      郵便番号: {
        type: "string",
        title: "郵便番号",
      },
      住所１: {
        type: "string",
        title: "住所１",
      },
      住所２: {
        type: "string",
        title: "住所２",
      },
      住所３: {
        type: "string",
        title: "住所３",
      },
      電話番号: {
        type: "string",
        title: "電話番号",
        nullable: true,
      },
      FAX番号: {
        type: "string",
        title: "FAX番号",
        nullable: true,
      },
      メールアドレス: {
        type: "string",
        title: "メールアドレス",
        nullable: true,
      },
      請求先担当者: {
        type: "string",
        title: "請求先担当者",
        nullable: true,
      },
      請求担当社員コード: {
        type: "string",
        title: "請求担当社員コード",
      },
      締日区分コード: {
        type: "string",
        title: "締日区分コード",
      },
      請求営業所コード: {
        type: "string",
        title: "請求営業所コード",
      },
      銀行口座ID: {
        type: "number",
        title: "銀行口座ID",
      },
      備考: {
        type: "string",
        title: "備考",
        nullable: true,
      },
    },
    required: [
      "荷主コード",
      "表紙分割コード",
      "表紙名",
      "郵便番号",
      "住所１",
      "住所２",
      "住所３",
      "請求担当社員コード",
      "締日区分コード",
      "請求書作成区分コード",
      "請求書印刷区分コード",
      "明細小計表示区分コード",
      "品代端数計算区分コード",
      //"消費税表示区分コード",
      "消費税計算区分コード",
      "明細ソート区分コード",
      //"高速料税込区分コード",
      "コース編集区分コード",
      "請求営業所コード",
      "請求先名",
      "銀行口座ID",
    ],
  }

export const 荷主請求マスタ月固定Schema: JSONSchemaType<荷主請求マスタ月固定> =
  {
    title: "荷主請求マスタ月固定",
    type: "object",
    properties: {
      請求書作成区分コード: {
        type: "string",
        enum: ["2"],
        title: "請求書作成区分コード",
      },
      請求書印刷区分コード: {
        type: "string",
        title: "請求書印刷区分コード",
      },
      明細小計表示区分コード: {
        type: "string",
        title: "明細小計表示区分コード",
      },
      // 消費税表示区分コード: {
      //   type: "string",
      //   title: "消費税表示区分コード",
      // },
      消費税計算区分コード: {
        type: "string",
        title: "消費税計算区分コード",
      },
      明細ソート区分コード: {
        type: "string",
        title: "明細ソート区分コード",
      },
      // 高速料税込区分コード: {
      //   type: "string",
      //   title: "高速料税込区分コード",
      // },
      荷主コード: {
        type: "string",
        title: "荷主コード",
      },
      表紙分割コード: {
        type: "string",
        title: "表紙分割コード",
      },
      表紙名: {
        type: "string",
        title: "表紙名",
      },
      請求先名: {
        type: "string",
        title: "請求先名",
        nullable: true,
      },
      郵便番号: {
        type: "string",
        title: "郵便番号",
      },
      住所１: {
        type: "string",
        title: "住所１",
      },
      住所２: {
        type: "string",
        title: "住所２",
      },
      住所３: {
        type: "string",
        title: "住所３",
      },
      電話番号: {
        type: "string",
        title: "電話番号",
        nullable: true,
      },
      FAX番号: {
        type: "string",
        title: "FAX番号",
        nullable: true,
      },
      メールアドレス: {
        type: "string",
        title: "メールアドレス",
        nullable: true,
      },
      請求先担当者: {
        type: "string",
        title: "請求先担当者",
        nullable: true,
      },
      請求担当社員コード: {
        type: "string",
        title: "請求担当社員コード",
      },
      締日区分コード: {
        type: "string",
        title: "締日区分コード",
      },
      請求営業所コード: {
        type: "string",
        title: "請求営業所コード",
      },
      銀行口座ID: {
        type: "number",
        title: "銀行口座ID",
      },
      備考: {
        type: "string",
        title: "備考",
        nullable: true,
      },
    },
    required: [
      "荷主コード",
      "表紙分割コード",
      "表紙名",
      "郵便番号",
      "住所１",
      "住所２",
      "住所３",
      "請求担当社員コード",
      "締日区分コード",
      "請求書作成区分コード",
      "請求書印刷区分コード",
      "明細小計表示区分コード",
      //"消費税表示区分コード",
      "消費税計算区分コード",
      "明細ソート区分コード",
      //"高速料税込区分コード",
      "請求営業所コード",
      "請求先名",
      "銀行口座ID",
    ],
  }

export const 荷主請求マスタ手作成Schema: JSONSchemaType<荷主請求マスタ手作成> =
  {
    title: "荷主請求マスタ手作成",
    type: "object",
    properties: {
      請求書作成区分コード: {
        enum: ["3"],
        type: "string",
        title: "請求書作成区分コード",
      },
      荷主コード: {
        type: "string",
        title: "荷主コード",
      },
      表紙分割コード: {
        type: "string",
        title: "表紙分割コード",
      },
      表紙名: {
        type: "string",
        title: "表紙名",
      },
      請求先名: {
        type: "string",
        title: "請求先名",
        nullable: true,
      },
      郵便番号: {
        type: "string",
        title: "郵便番号",
      },
      住所１: {
        type: "string",
        title: "住所１",
      },
      住所２: {
        type: "string",
        title: "住所２",
      },
      住所３: {
        type: "string",
        title: "住所３",
      },
      電話番号: {
        type: "string",
        title: "電話番号",
        nullable: true,
      },
      FAX番号: {
        type: "string",
        title: "FAX番号",
        nullable: true,
      },
      メールアドレス: {
        type: "string",
        title: "メールアドレス",
        nullable: true,
      },
      請求先担当者: {
        type: "string",
        title: "請求先担当者",
        nullable: true,
      },
      請求担当社員コード: {
        type: "string",
        title: "請求担当社員コード",
      },
      締日区分コード: {
        type: "string",
        title: "締日区分コード",
      },
      請求営業所コード: {
        type: "string",
        title: "請求営業所コード",
      },
      銀行口座ID: {
        type: "number",
        title: "銀行口座ID",
      },
      備考: {
        type: "string",
        title: "備考",
        nullable: true,
      },
    },
    required: [
      "荷主コード",
      "表紙分割コード",
      "表紙名",
      "郵便番号",
      "住所１",
      "住所２",
      "住所３",
      "請求担当社員コード",
      "締日区分コード",
      "請求書作成区分コード",
      "請求営業所コード",
      "請求先名",
      "銀行口座ID",
    ],
  }

export const ninusiSeikyuRegisterPostReqSchema = {
  anyOf: [
    {
      ...荷主請求マスタ受注配車Schema,
    },
    {
      ...荷主請求マスタ月固定Schema,
    },
    {
      ...荷主請求マスタ手作成Schema,
    },
  ],
}

export const ninusiSeikyuUpdatePutReqSchema = {
  anyOf: [
    {
      allOf: [
        {
          ...荷主請求マスタ受注配車Schema,
        },
        {
          type: "object",
          properties: {
            更新日時: {
              type: "string",
              title: "更新日時",
            },
          },
          required: ["更新日時"],
        },
      ],
    },
    {
      allOf: [
        {
          ...荷主請求マスタ月固定Schema,
        },
        {
          type: "object",
          properties: {
            更新日時: {
              type: "string",
              title: "更新日時",
            },
          },
          required: ["更新日時"],
        },
      ],
    },
    {
      allOf: [
        {
          ...荷主請求マスタ手作成Schema,
        },
        {
          type: "object",
          properties: {
            更新日時: {
              type: "string",
              title: "更新日時",
            },
          },
          required: ["更新日時"],
        },
      ],
    },
  ],
}

export const ninusiSeikyuUtiwakePutReqSchema: JSONSchemaType<TNinusiSeikyuUtiwakePutReq> =
  {
    type: "object",
    properties: {
      荷主請求内訳ID: {
        type: "number",
        nullable: true,
        title: "荷主請求内訳ID",
        errorMessage: util.stringErrorMessage("荷主請求内訳ID", {
          required: false,
        }),
      },
      荷主請求ID: {
        type: "number",
        title: "荷主請求ID",
        nullable: true,
        errorMessage: util.stringErrorMessage("表紙名", {
          required: true,
        }),
      },
      請求内訳コード: {
        type: "string",
        title: "請求内訳コード",
        minLength: 1,
        maxLength: validateConstant.LENGTH.請求内訳コード,
        errorMessage: util.stringErrorMessage("請求内訳コード", {
          required: true,
          maxLength: validateConstant.LENGTH.請求内訳コード,
        }),
      },
      請求内訳名: {
        type: "string",
        title: "請求内訳名",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        errorMessage: util.stringErrorMessage("請求内訳名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      請求内訳担当社員コード: {
        type: "string",
        nullable: true,
        title: "請求内訳担当社員コード",
        maxLength: validateConstant.LENGTH.社員コード,
        errorMessage: util.stringErrorMessage("請求内訳担当社員コード", {
          required: false,
          maxLength: validateConstant.LENGTH.社員コード,
        }),
      },
      月固定フラグ: {
        type: "number",
        nullable: true,
        title: "月固定フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("月固定フラグ", {
          required: false,
        }),
      },
      乗務員売上フラグ: {
        type: "number",
        nullable: true,
        title: "乗務員売上フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("乗務員売上フラグ", {
          required: false,
        }),
      },
      計上基準日区分コード: {
        type: "string",
        title: "計上基準日区分コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("計上基準日区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      請求車輌区分コード: {
        type: "string",
        title: "請求車輌区分コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("請求車輌区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      運賃タリフフラグ: {
        type: "number",
        nullable: true,
        title: "運賃タリフフラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("運賃タリフフラグ", {
          required: false,
        }),
      },
      トン数補償フラグ: {
        type: "number",
        nullable: true,
        title: "トン数補償フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("トン数補償フラグ", {
          required: false,
        }),
      },
      乗務員手当フラグ: {
        type: "number",
        nullable: true,
        title: "乗務員手当フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("乗務員売上フラグ", {
          required: false,
        }),
      },
      高速料請求フラグ: {
        type: "number",
        nullable: true,
        title: "高速料請求フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("高速料請求フラグ", {
          required: false,
        }),
      },
      運行売上外フラグ: {
        type: "number",
        nullable: true,
        title: "運行売上外フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("運行売上外フラグ", {
          required: false,
        }),
      },
      定額車輌ID: {
        type: "number",
        nullable: true,
        title: "定額車輌ID",
        errorMessage: util.stringErrorMessage("定額車輌ID", {
          required: false,
        }),
      },
      固定請求課税区分コード: {
        type: "string",
        nullable: true,
        title: "固定請求課税区分コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("固定請求課税区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      固定請求額: {
        type: "integer",
        nullable: true,
        title: "固定請求額",
        errorMessage: util.stringErrorMessage("定額車輌ID", {
          required: false,
        }),
      },
      備考: {
        type: "string",
        nullable: true,
        title: "備考",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("固定請求課税区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      計上部所コード: {
        type: "string",
        nullable: true,
        title: "計上部所コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("計上部所コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      計上乗務員ID: {
        type: "number",
        nullable: true,
        title: "計上乗務員ID",
        errorMessage: util.stringErrorMessage("計上乗務員ID", {
          required: false,
        }),
      },
      更新日時: {
        type: "string",
        nullable: true,
        title: "更新日時",
        errorMessage: util.stringErrorMessage("更新日時", {
          required: true,
        }),
      },
      削除フラグ: {
        type: "number",
        title: "削除フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("削除フラグ", {
          required: false,
        }),
      },
    },
    required: ["削除フラグ", "荷主請求ID", "請求内訳コード", "請求内訳名"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "更新日時",
        "荷主請求内訳ID",
        "削除フラグ",
        ["荷主請求ID", "表紙名"],
        "請求内訳コード",
        "請求内訳名",
      ]),
    },
  }
